import AppButton from "@/components/AppButtons";
import Reveal, { Eyebrow } from "@/components/Reveal";
import { SITE } from "@/config/site";

function AppCard({ app, monogram, testid }) {
  return (
    <article
      data-testid={testid}
      className="noise-dark group relative flex h-full flex-col overflow-hidden rounded-3xl bg-ink p-8 text-white shadow-ambient transition-transform duration-300 hover:-translate-y-1 lg:p-10"
    >
      <p
        className="pointer-events-none absolute -bottom-14 -right-6 select-none font-cabinet text-[11rem] font-extrabold leading-none text-white/5"
        aria-hidden="true"
      >
        {monogram}
      </p>
      <div className="flex items-center justify-between">
        <div className="flex gap-1.5" aria-hidden="true">
          <span className="h-2.5 w-2.5 rounded-full bg-white/20" />
          <span className="h-2.5 w-2.5 rounded-full bg-white/20" />
          <span className="h-2.5 w-2.5 rounded-full bg-white/20" />
        </div>
        <span className="rounded-full border border-white/20 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-white/60">
          Postings Technology
        </span>
      </div>
      <span className="mt-9 grid h-12 w-12 place-items-center rounded-2xl bg-white/10 font-cabinet text-sm font-bold text-accent">
        {monogram}
      </span>
      <h3 className="mt-5 font-cabinet text-2xl font-bold tracking-tight">{app.name}</h3>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-white/65">{app.blurb}</p>
      <div className="mt-auto pt-9">
        <AppButton app={app} variant="accent" size="md" testid={`apps-launch-${monogram.toLowerCase()}`} />
      </div>
    </article>
  );
}

export default function AppsSection() {
  return (
    <section id="apps" className="py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <Eyebrow>Client Technology</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-5 font-cabinet text-4xl font-extrabold tracking-tighter sm:text-5xl">
              Your Business. Your Information. Easy Access.
            </h2>
          </Reveal>
          <Reveal delay={0.14}>
            <p className="mt-5 text-lg leading-relaxed text-slate-600">
              Postings combines professional service with secure digital tools that help you
              communicate and manage information more efficiently.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-12">
          <Reveal className="md:col-span-7">
            <AppCard app={SITE.apps.clientManager} monogram="CM" testid="apps-card-client-manager" />
          </Reveal>
          <Reveal delay={0.1} className="md:col-span-5">
            <AppCard app={SITE.apps.postWage} monogram="PW" testid="apps-card-postwage" />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
